import React from 'react'
import ReactDOM from 'react-dom'
import { useTransition, animated } from '@react-spring/web'
import { twMerge } from 'tailwind-merge'

export const Mask = React.memo(
  (props: {
    isVisible: boolean
    className?: string
    onClick?: React.MouseEventHandler
    onRest?: () => void
  }) => {
    const transitions = useTransition(
      props.isVisible ? [props.isVisible] : [],
      {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: {
          friction: 35,
          tension: 400,
        },
        onRest: props.onRest,
      },
    )

    return ReactDOM.createPortal(
      transitions((styles, isVisible) => (
        <animated.button
          className={twMerge(
            'bg-base-300/80 fixed top-0 left-0 right-0 bottom-0 z-100 w-full h-full',
            props.className,
          )}
          style={styles}
          key='mask'
          onClick={props.onClick}
        />
      )),
      document.body,
    )
  },
)
